module.exports = __webpack_public_path__ + "static/media/background-glass-seals-2.cef71c3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-glass-seals-2.jpg
// module id = 957
// module chunks = 0